// MainLayout.js

import React from "react";
// Typically you import the Banner, DesktopLayout, and MobileLayout:
import Banner from "../components/Banner";
import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";

/**
 * The MainLayout decides if we should use the Desktop or Mobile layout.
 * It also renders the banner (scrolling sponsor text) if desired.
 */
function MainLayout({
  // We expect these props from a parent (like Canvas.js):
  isMobile,
  // The rest of your props, for example:
  canvasRef,
  uploadedImage,
  setUploadedImage,
  uploadedImageObj,
  bgImage,
  setBgImage,
  activeTab,
  setActiveTab,
  layers,
  drawCanvas,
  updateAnySelected,
  selectedTextIsWhite,
  setSelectedTextIsWhite,
  selectedFontFamily,
  setSelectedFontFamily,
  isBold,
  setIsBold,
  isItalic,
  setIsItalic,
  isUnderlined,
  setIsUnderlined,
  isStrikethrough,
  setIsStrikethrough,
  isAllCaps,
  setIsAllCaps,
  textOpacity,
  setTextOpacity,
  clampTextInsideBgRect,
  topTextInput,
  setTopTextInput,
  bottomTextInput,
  setBottomTextInput,
  extraTextInputs,
  setExtraTextInputs,
  handleSetBackgroundFromUrl,
  handleAddNftAsAsset,
  handleRemoveBackground,
  handleImageUpload,
  category,
  setCategory,
  isAssetAdded,
  setIsAssetAdded,
  originalBgDataRef,
  preDeepFryCanvasRef,
  preDeepFryLayersRef,
  anySelected,
  handleDeleteSelected,
  isErasing,
  setIsErasing,
  eraserSize,
  setEraserSize,
  handleUndoLastErase,
  handleClearAllErases,
  eraserStrokesRef,
  bgRect,
  satValue,
  setSatValue,
  conValue,
  setConValue,
  briValue,
  setBriValue,
  hueValue,
  setHueValue,
  pixValue,
  setPixValue,
  noiseValue,
  setNoiseValue,
  hasDeepFried,
  setHasDeepFried,
  satEnabled,
  setSatEnabled,
  conEnabled,
  setConEnabled,
  briEnabled,
  setBriEnabled,
  hueEnabled,
  setHueEnabled,
  pixEnabled,
  setPixEnabled,
  noiseEnabled,
  setNoiseEnabled,
  assetsAreReady,
  setAssetsAreReady,
  loadingAssets,
  setLoadingAssets,
  forceUpdateLayers,
  layersVersion,
}) {
  return (
    <div className="flex flex-col items-center min-h-screen w-full bg-monadBg text-center font-shareTechMono">
      {/* BANNER (optional) */}
      <Banner />

      {/* 
        Now decide which layout to use. 
        If isMobile === true => <MobileLayout />, else <DesktopLayout />.
      */}
      {isMobile ? (
        <MobileLayout
          canvasRef={canvasRef}
          uploadedImage={uploadedImage}
          uploadedImageObj={uploadedImageObj}
          bgImage={bgImage}
          setBgImage={setBgImage}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          layers={layers}
          drawCanvas={drawCanvas}
          updateAnySelected={updateAnySelected}
          selectedTextIsWhite={selectedTextIsWhite}
          setSelectedTextIsWhite={setSelectedTextIsWhite}
          selectedFontFamily={selectedFontFamily}
          setSelectedFontFamily={setSelectedFontFamily}
          isBold={isBold}
          setIsBold={setIsBold}
          isItalic={isItalic}
          setIsItalic={setIsItalic}
          isUnderlined={isUnderlined}
          setIsUnderlined={setIsUnderlined}
          isStrikethrough={isStrikethrough}
          setIsStrikethrough={setIsStrikethrough}
          isAllCaps={isAllCaps}
          setIsAllCaps={setIsAllCaps}
          textOpacity={textOpacity}
          setTextOpacity={setTextOpacity}
          clampTextInsideBgRect={clampTextInsideBgRect}
          topTextInput={topTextInput}
          setTopTextInput={setTopTextInput}
          bottomTextInput={bottomTextInput}
          setBottomTextInput={setBottomTextInput}
          extraTextInputs={extraTextInputs}
          setExtraTextInputs={setExtraTextInputs}
          handleSetBackgroundFromUrl={handleSetBackgroundFromUrl}
          handleAddNftAsAsset={handleAddNftAsAsset}
          handleRemoveBackground={handleRemoveBackground}
          handleImageUpload={handleImageUpload}
          category={category}
          setCategory={setCategory}
          isAssetAdded={isAssetAdded}
          setIsAssetAdded={setIsAssetAdded}
          originalBgDataRef={originalBgDataRef}
          preDeepFryCanvasRef={preDeepFryCanvasRef}
          preDeepFryLayersRef={preDeepFryLayersRef}
          anySelected={anySelected}
          handleDeleteSelected={handleDeleteSelected}
          isErasing={isErasing}
          setIsErasing={setIsErasing}
          eraserSize={eraserSize}
          setEraserSize={setEraserSize}
          handleUndoLastErase={handleUndoLastErase}
          handleClearAllErases={handleClearAllErases}
          eraserStrokesRef={eraserStrokesRef}
          bgRect={bgRect}
          satValue={satValue}
          setSatValue={setSatValue}
          conValue={conValue}
          setConValue={setConValue}
          briValue={briValue}
          setBriValue={setBriValue}
          hueValue={hueValue}
          setHueValue={setHueValue}
          pixValue={pixValue}
          setPixValue={setPixValue}
          noiseValue={noiseValue}
          setNoiseValue={setNoiseValue}
          hasDeepFried={hasDeepFried}
          setHasDeepFried={setHasDeepFried}
          satEnabled={satEnabled} setSatEnabled={setSatEnabled}
          conEnabled={conEnabled} setConEnabled={setConEnabled}
          briEnabled={briEnabled} setBriEnabled={setBriEnabled}
          hueEnabled={hueEnabled} setHueEnabled={setHueEnabled}
          pixEnabled={pixEnabled} setPixEnabled={setPixEnabled}
          noiseEnabled={noiseEnabled} setNoiseEnabled={setNoiseEnabled}
          assetsAreReady={assetsAreReady}
          setAssetsAreReady={setAssetsAreReady}
          loadingAssets={loadingAssets}
          setLoadingAssets={setLoadingAssets}
          setUploadedImage={setUploadedImage}
          forceUpdateLayers={forceUpdateLayers}
          layersVersion={layersVersion}
        />
      ) : (
        <DesktopLayout
          canvasRef={canvasRef}
          uploadedImage={uploadedImage}
          uploadedImageObj={uploadedImageObj}
          bgImage={bgImage}
          setBgImage={setBgImage}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          layers={layers}
          drawCanvas={drawCanvas}
          updateAnySelected={updateAnySelected}
          selectedTextIsWhite={selectedTextIsWhite}
          setSelectedTextIsWhite={setSelectedTextIsWhite}
          selectedFontFamily={selectedFontFamily}
          setSelectedFontFamily={setSelectedFontFamily}
          isBold={isBold}
          setIsBold={setIsBold}
          isItalic={isItalic}
          setIsItalic={setIsItalic}
          isUnderlined={isUnderlined}
          setIsUnderlined={setIsUnderlined}
          isStrikethrough={isStrikethrough}
          setIsStrikethrough={setIsStrikethrough}
          isAllCaps={isAllCaps}
          setIsAllCaps={setIsAllCaps}
          textOpacity={textOpacity}
          setTextOpacity={setTextOpacity}
          clampTextInsideBgRect={clampTextInsideBgRect}
          topTextInput={topTextInput}
          setTopTextInput={setTopTextInput}
          bottomTextInput={bottomTextInput}
          setBottomTextInput={setBottomTextInput}
          extraTextInputs={extraTextInputs}
          setExtraTextInputs={setExtraTextInputs}
          handleSetBackgroundFromUrl={handleSetBackgroundFromUrl}
          handleAddNftAsAsset={handleAddNftAsAsset}
          handleRemoveBackground={handleRemoveBackground}
          handleImageUpload={handleImageUpload}
          category={category}
          setCategory={setCategory}
          isAssetAdded={isAssetAdded}
          setIsAssetAdded={setIsAssetAdded}
          originalBgDataRef={originalBgDataRef}
          preDeepFryCanvasRef={preDeepFryCanvasRef}
          preDeepFryLayersRef={preDeepFryLayersRef}
          anySelected={anySelected}
          handleDeleteSelected={handleDeleteSelected}
          isErasing={isErasing}
          setIsErasing={setIsErasing}
          eraserSize={eraserSize}
          setEraserSize={setEraserSize}
          handleUndoLastErase={handleUndoLastErase}
          handleClearAllErases={handleClearAllErases}
          eraserStrokesRef={eraserStrokesRef}
          bgRect={bgRect}
          satValue={satValue}
          setSatValue={setSatValue}
          conValue={conValue}
          setConValue={setConValue}
          briValue={briValue}
          setBriValue={setBriValue}
          hueValue={hueValue}
          setHueValue={setHueValue}
          pixValue={pixValue}
          setPixValue={setPixValue}
          noiseValue={noiseValue}
          setNoiseValue={setNoiseValue}
          hasDeepFried={hasDeepFried}
          setHasDeepFried={setHasDeepFried}
          satEnabled={satEnabled} setSatEnabled={setSatEnabled}
          conEnabled={conEnabled} setConEnabled={setConEnabled}
          briEnabled={briEnabled} setBriEnabled={setBriEnabled}
          hueEnabled={hueEnabled} setHueEnabled={setHueEnabled}
          pixEnabled={pixEnabled} setPixEnabled={setPixEnabled}
          noiseEnabled={noiseEnabled} setNoiseEnabled={setNoiseEnabled}
          assetsAreReady={assetsAreReady}
          setAssetsAreReady={setAssetsAreReady}
          loadingAssets={loadingAssets}
          setLoadingAssets={setLoadingAssets}
          setUploadedImage={setUploadedImage}
          forceUpdateLayers={forceUpdateLayers}
          layersVersion={layersVersion}
        />
      )}
    </div>
  );
}

export default MainLayout;
